import { NAVY } from '../utils/constants';

const opsCard = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 16,
  background: '#ffffff',
  border: '1px solid var(--color-border)',
  borderRadius: 14,
  padding: '22px 24px',
  cursor: 'pointer',
  textAlign: 'left',
  width: '100%',
  boxShadow: '0 1px 6px rgba(10,22,40,0.06)',
  transition: 'border-color 0.15s, box-shadow 0.15s',
};

export default function Operations({ onNavigate }) {
  return (
    <div>
      <div className="back-row">
        <button className="back-btn" onClick={() => onNavigate('home')}>← Home</button>
      </div>

      <h2 style={{ fontSize: '1.2rem', fontWeight: 800, color: NAVY, marginBottom: 4 }}>Operations</h2>
      <p style={{ fontSize: '0.8rem', color: 'var(--color-ink-muted)', marginBottom: 28 }}>
        Tools for day-of operations and reporting.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <button
          style={opsCard}
          onClick={() => onNavigate('daily-tracker')}
          onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#C9A84C'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(201,168,76,0.14)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--color-border)'; e.currentTarget.style.boxShadow = '0 1px 6px rgba(10,22,40,0.06)'; }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '1rem', fontWeight: 700, color: NAVY, marginBottom: 4 }}>Daily Tracker</div>
            <div style={{ fontSize: '0.8rem', color: 'var(--color-ink-muted)', lineHeight: 1.5 }}>
              Spreadsheet-style daily booking tracker. Edit operational fields, track payments and tickets, and export to Excel.
            </div>
          </div>
          <span style={{ fontSize: '1.3rem', color: '#C9A84C', flexShrink: 0, fontWeight: 700 }}>→</span>
        </button>

        <button
          style={opsCard}
          onClick={() => onNavigate('seating-sheet')}
          onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#C9A84C'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(201,168,76,0.14)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--color-border)'; e.currentTarget.style.boxShadow = '0 1px 6px rgba(10,22,40,0.06)'; }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '1rem', fontWeight: 700, color: NAVY, marginBottom: 4 }}>Seating Sheet</div>
            <div style={{ fontSize: '0.8rem', color: 'var(--color-ink-muted)', lineHeight: 1.5 }}>
              Visual boat floor plan — assign guests to tables, track boarding, and auto-assign by group size.
            </div>
          </div>
          <span style={{ fontSize: '1.3rem', color: '#C9A84C', flexShrink: 0, fontWeight: 700 }}>→</span>
        </button>

        <button
          style={opsCard}
          onClick={() => onNavigate('reports')}
          onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#C9A84C'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(201,168,76,0.14)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--color-border)'; e.currentTarget.style.boxShadow = '0 1px 6px rgba(10,22,40,0.06)'; }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '1rem', fontWeight: 700, color: NAVY, marginBottom: 4 }}>Quick Reports</div>
            <div style={{ fontSize: '0.8rem', color: 'var(--color-ink-muted)', lineHeight: 1.5 }}>
              Single-day financial report — pax summary, revenue reconciliation, partner TAC, payment status, bank transfers, and adjustments.
            </div>
          </div>
          <span style={{ fontSize: '1.3rem', color: '#C9A84C', flexShrink: 0, fontWeight: 700 }}>→</span>
        </button>

        <button
          style={opsCard}
          onClick={() => onNavigate('range-reports')}
          onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#C9A84C'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(201,168,76,0.14)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--color-border)'; e.currentTarget.style.boxShadow = '0 1px 6px rgba(10,22,40,0.06)'; }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '1rem', fontWeight: 700, color: NAVY, marginBottom: 4 }}>Range Reports</div>
            <div style={{ fontSize: '0.8rem', color: 'var(--color-ink-muted)', lineHeight: 1.5 }}>
              Multi-day financial reports with preset periods — pax summary, revenue, payment status. Password protected. Export to Excel or PDF.
            </div>
          </div>
          <span style={{ fontSize: '1.3rem', color: '#C9A84C', flexShrink: 0, fontWeight: 700 }}>→</span>
        </button>

        <button
          style={opsCard}
          onClick={() => onNavigate('import-data')}
          onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#C9A84C'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(201,168,76,0.14)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--color-border)'; e.currentTarget.style.boxShadow = '0 1px 6px rgba(10,22,40,0.06)'; }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '1rem', fontWeight: 700, color: NAVY, marginBottom: 4 }}>Import Data</div>
            <div style={{ fontSize: '0.8rem', color: 'var(--color-ink-muted)', lineHeight: 1.5 }}>
              Import daily booking data from Excel tracker files — upload an .xlsx file to populate all bookings for a selected date.
            </div>
          </div>
          <span style={{ fontSize: '1.3rem', color: '#C9A84C', flexShrink: 0, fontWeight: 700 }}>→</span>
        </button>
      </div>
    </div>
  );
}
